<template>
<div>

  <el-form class="default-form" inline="true"  style="display: flex">

    <el-form-item label="不合格数量">
    <el-input-number v-model="this.unQualifyNum" :min="1" :max="this.parentData.checked_count" @change="countQu"/>
    </el-form-item>

    <el-form-item label="合格数量">
      <el-input-number v-model="this.qualifyNum" :min="0" :max="this.parentData.checked_count - 1" @change="countUnQu"/>
    </el-form-item>

    <el-form-item>
      <el-button type="success" @click="split">拆分</el-button>
    </el-form-item>

  </el-form>

</div>
</template>

<script>
export default {
  name: "BusXingCaiUnqualifiedSplit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      qualifyNum:0,
      unQualifyNum:0
    }
  },
  methods:{
    countUnQu(){
      this.unQualifyNum = this.parentData.checked_count - this.qualifyNum
    },
    countQu(){
      this.qualifyNum = this.parentData.checked_count - this.unQualifyNum
    },

    async split(){
      this.parentData.unQualifyNum = this.unQualifyNum
      this.parentData.qualifyNum = this.qualifyNum
      let {data: res} = await this.$axios.post('/api/xingcai/unqualifiedSplit',this.parentData);
      if (res.success){
        this.$message.success("拆分成功！")
        this.setting.$fn.closeWindow()
        this.setting.$fn.reSearch()
      }else {
        this.$message.error("拆分失败！")
      }
    }
  },
  created() {
    this.unQualifyNum = this.parentData.checked_count
  }

}
</script>

<style scoped>

</style>